/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface DailyChargingSuccessRateDto
 */
export interface DailyChargingSuccessRateDto {
    /**
     * The date for this data point
     * @type {Date}
     * @memberof DailyChargingSuccessRateDto
     */
    date?: Date;
    /**
     * The charging success rate as a percentage (0-100)
     * @type {number}
     * @memberof DailyChargingSuccessRateDto
     */
    chargingSuccessRate?: number;
    /**
     * Number of successful charging sessions
     * @type {number}
     * @memberof DailyChargingSuccessRateDto
     */
    successfulSessions?: number;
    /**
     * Number of failed charging sessions
     * @type {number}
     * @memberof DailyChargingSuccessRateDto
     */
    failedSessions?: number;
    /**
     * Total number of charging sessions (successful + failed)
     * @type {number}
     * @memberof DailyChargingSuccessRateDto
     */
    totalSessions?: number;
}

/**
 * Check if a given object implements the DailyChargingSuccessRateDto interface.
 */
export function instanceOfDailyChargingSuccessRateDto(
    value: object,
): value is DailyChargingSuccessRateDto {
    return true;
}

export function DailyChargingSuccessRateDtoFromJSON(
    json: any,
): DailyChargingSuccessRateDto {
    return DailyChargingSuccessRateDtoFromJSONTyped(json, false);
}

export function DailyChargingSuccessRateDtoFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): DailyChargingSuccessRateDto {
    if (json == null) {
        return json;
    }
    return {
        date: json["date"] == null ? undefined : new Date(json["date"]),
        chargingSuccessRate:
            json["chargingSuccessRate"] == null
                ? undefined
                : json["chargingSuccessRate"],
        successfulSessions:
            json["successfulSessions"] == null
                ? undefined
                : json["successfulSessions"],
        failedSessions:
            json["failedSessions"] == null ? undefined : json["failedSessions"],
        totalSessions:
            json["totalSessions"] == null ? undefined : json["totalSessions"],
    };
}

export function DailyChargingSuccessRateDtoToJSON(
    value?: DailyChargingSuccessRateDto | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        date: value["date"] == null ? undefined : value["date"].toISOString(),
        chargingSuccessRate: value["chargingSuccessRate"],
        successfulSessions: value["successfulSessions"],
        failedSessions: value["failedSessions"],
        totalSessions: value["totalSessions"],
    };
}
